import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { Toggle } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import validate from '../../components/tenant_application/validate';

import { AccentColor } from 'helpers/AccentColorHelper';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import ApplicationReviewNotificationsSettings from './ApplicationReviewNotificationsSettings';
import ApplicationApprovalNotificationsSettings from './ApplicationApprovalNotificationsSettings';

const style = {
  button: {
    color: 'white',
    height: '40px',
    textAlign: 'center',
    margin: 'auto',
    marginTop: '10px',
  },
  description: {
    margin: '0',
    fontSize: '14px',
    maxWidth: '500px',
  },
};

const maintenanceNotificationDescription = {
  agent: (
    <p style={style.description}>
      {getTranslatedString(
        'landlordPortal.userPreferencesForm.maintenanceNotificationDescription.agent',
        {
          serviceRequestCap: serviceRequestVerbiage('capitalized'),
          serviceRequest: serviceRequestVerbiage('translated'),
        }
      )}
    </p>
  ),
  lead: (
    <p style={style.description}>
      {getTranslatedString(
        'landlordPortal.userPreferencesForm.maintenanceNotificationDescription.lead',
        {
          serviceRequestCap: serviceRequestVerbiage('capitalized'),
          serviceRequest: serviceRequestVerbiage('translated'),
        }
      )}
    </p>
  ),
};

const paymentDescription = {
  agent: (
    <p style={style.description}>
      {getTranslatedString('landlordPortal.userPreferencesForm.paymentDescription.agent')}
    </p>
  ),
  lead: (
    <p style={style.description}>
      {getTranslatedString('landlordPortal.userPreferencesForm.paymentDescription.lead')}
    </p>
  ),
};

class UserPreferencesForm extends Component {
  filterUserPreferencesBasedOnType = (userType) => {
    let preferences = [
      {
        name: 'application_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.applicationNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.description.applicationNotifications'
            )}
          </p>
        ),
      },
      {
        name: 'payment_reminders',
        label:
          userType === 'lead'
            ? getTranslatedString('landlordPortal.userPreferencesForm.label.paymentReminders.lead')
            : getTranslatedString(
                'landlordPortal.userPreferencesForm.label.paymentReminders.agent'
              ),
        description: paymentDescription[userType],
      },
      {
        name: 'sign_lease_reminders',
        label: getTranslatedString('landlordPortal.userPreferencesForm.label.leaseReminders'),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.leaseReminders.description'
            )}
          </p>
        ),
      },
      {
        name: 'lease_completion_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.leaseCompletionNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.leaseCompletionNotifications.description'
            )}
          </p>
        ),
      },
      {
        name: 'application_cancellation_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.applicationCancellationNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.applicationCancellationNotifications.description'
            )}
          </p>
        ),
      },
      userType === 'agent' && {
        name: 'application_review_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.applicationReviewNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.applicationReviewNotifications.description'
            )}
          </p>
        ),
        children: <ApplicationReviewNotificationsSettings />,
      },
      userType === 'agent' && {
        name: 'application_approval_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.applicationApprovalNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.applicationApprovalNotifications.description'
            )}
          </p>
        ),
        children: <ApplicationApprovalNotificationsSettings />,
      },
      {
        name: 'maintenance_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.maintenanceNotification',
          { serviceRequest: serviceRequestVerbiage('titlecase') }
        ),
        description: maintenanceNotificationDescription[userType],
      },
      {
        name: 'amenity_booked_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.amenityBookedNotification'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.amenityBookedNotification.description'
            )}
          </p>
        ),
      },
      {
        name: 'amenity_cancelled_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.amenityCancelledNotification'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.amenityCancelledNotification.description'
            )}
          </p>
        ),
      },
      {
        name: 'messaging_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.messagingNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.messagingNotifications.description'
            )}
          </p>
        ),
      },
      {
        name: 'lease_approval_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.leaseApprovalNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.leaseApprovalNotifications.description'
            )}
          </p>
        ),
      },
      {
        name: 'renters_insurance_upload_confirmation',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.rentersInsuranceConfirmationNotifications'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.description.rentersInsuranceConfirmationNotifications'
            )}
          </p>
        ),
      },
    ].filter(Boolean);

    if (featureEnabled('purchase_order')) {
      preferences.push({
        name: 'purchase_order_notifications',
        label: getTranslatedString(
          'landlordPortal.userPreferencesForm.label.purchaseOrderNotification'
        ),
        description: (
          <p style={style.description}>
            {getTranslatedString(
              'landlordPortal.userPreferencesForm.label.purchaseOrderNotification.description'
            )}
          </p>
        ),
      });
    }

    if (userType === 'lead') {
      preferences = preferences.filter((preference) => {
        return ['payment_reminders', 'maintenance_notifications'].includes(preference.name);
      });
    }

    if (hostIsCapreit()) {
      preferences = preferences.filter((preference) => {
        return [
          'maintenance_notifications',
          'amenity_cancelled_notifications',
          'amenity_booked_notifications',
        ].includes(preference.name);
      });
    }

    return preferences.map((preference, index) => (
      <div
        key={index}
        style={{
          marginBottom: '15px',
          borderBottom: '1px solid rgba(0,0,0,0.1)',
          paddingBottom: '15px',
        }}
      >
        <Field
          name={preference.name}
          type="toggle"
          component={Toggle}
          label={
            <strong style={{ fontWeight: '900', fontSize: '16px' }}>{preference.label}</strong>
          }
          parse={Boolean}
        />
        {preference.description}
        {preference.children}
      </div>
    ));
  };

  render() {
    const { handleSubmit, userType } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div
          className="row"
          style={{ marginBottom: '15px', marginTop: '15px', marginLeft: '20px' }}
        >
          <div className="row">{this.filterUserPreferencesBasedOnType(userType)}</div>
          <div className="row" style={{ textAlign: 'center', height: '65px' }}>
            <FlatButton
              label={getTranslatedString('landlordPortal.userPreferences.update')}
              type="submit"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    );
  }
}

const ConnectComponent = connect((state) => ({
  initialValues: state.userTypes.userPreferences, // pull initial values from account reducer
}));

const ReduxFormComponent = reduxForm({
  form: 'user_preferences', // a unique identifier for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
  enableReinitialize: true,
});

export default compose(ConnectComponent, ReduxFormComponent)(UserPreferencesForm);
